{
  "form": {
    "input_placeholder": "Añadir una tarea…",
    "parseWithAi_aria": "Analizar tarea con IA",
    "parseWithAi_title": "Depura y establece la prioridad con IA",
    "priorityLabel_aria": "Prioridad de la tarea",
    "add": "Añadir",
    "signInForAi": "Inicia sesión para usar las funciones de IA.",
    "aiUnavailable": "IA no disponible. Inténtalo de nuevo.",
    "saveTo": "Guardar en",
    "saveTo_aria": "Guardar en {{list}}",
    "saveToSynced_aria": "Guardar en {{list}}, {{provider}}",
    "addedTo": "Añadido a {{list}}",
    "addedToSynced": "Añadido a {{list}} · {{provider}}",
    "show": "Mostrar"
  },
  "priority": {
    "Critical": "Crítica",
    "High": "Alta",
    "Medium": "Media",
    "Low": "Baja"
  },
  "item": {
    "edit_aria": "Editar tarea",
    "delete_aria": "Eliminar tarea",
    "addStep": "Añadir un paso",
    "addStep_placeholder": "Añadir un paso…",
    "addStep_aria": "Añadir un paso a {{task}}",
    "steps_group_aria": "Pasos de {{task}}",
    "steps_progress_aria": "{{done}} de {{count}} pasos completados",
    "completeSteps_aria": "{{task}}. También completa {{count}} pasos abiertos"
  },
  "list": {
    "title": "Tareas",
    "newListFallback": "Nueva lista",
    "completedMeta": "{{completed}} de {{total}} completadas",
    "deleteConfirm": "¿Eliminar \"{{name}}\"?",
    "rename_title": "Renombrar",
    "deleteList_title": "Eliminar lista",
    "newListName_placeholder": "Nombre de la lista…",
    "newList": "Nueva lista",
    "done": "Hecho",
    "emptyTitle": "Aún no hay tareas",
    "emptySubtitle": "Añade una abajo para empezar.",
    "noFilterMatch": "Ninguna tarea coincide con este filtro.",
    "createIn": "Crear en",
    "inDestination": "en {{destination}}",
    "createIn_aria": "Crear en {{destination}}",
    "createInAccount_aria": "Crear en {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Creando en {{destination}}…",
    "createFailed": "No se pudo crear «{{name}}» en {{destination}}.",
    "createLimit": "{{destination}} ha alcanzado su límite de listas.",
    "keepInRhemn": "Mantener en Rhemn"
  },
  "filter": {
    "label": "Filtrar",
    "all": "Todas"
  },
  "voice": {
    "mic_aria": "Añadir tareas por voz",
    "mic_title": "Di tus tareas — ordenadas por prioridad y momento",
    "stop_aria": "Detener y ordenar tareas",
    "recording": "Grabando",
    "sorting": "Ordenando tus tareas…",
    "stripTitle": "Tareas escuchadas",
    "stripCount": "{{checked}} de {{total}}",
    "discard": "Descartar",
    "addN": "Añadir {{count}}",
    "addZero": "Añadir",
    "adding": "Añadiendo…",
    "parseFallback": "No se pudo ordenar — tus palabras están en el cuadro.",
    "nothingHeard": "No se entendió — inténtalo de nuevo.",
    "micDenied": "El micrófono está bloqueado — permítelo en ajustes.",
    "gateBody": "Di tus tareas — ordenadas por prioridad y bloque de oración. Incluido con Pro.",
    "listen_aria": "Escuchando — di tus tareas"
  }
}
